var Type = function () {
  function Type(format, mode) {
    this.getNotAvailableDisplayComponent = mode.getNotAvailableDisplayComponent;
    this.getAvailableDisplayComponent = mode.getAvailableDisplayComponent;
    this.getDisplayComponent = mode.getDisplayComponent;
    this.getControlComponent = mode.getControlComponent;
    this.validate = format.validate;
    this.format = format.format;
    this.formatParams = format.formatParams;
  }

  return Type;
}();

export { Type };